import { I18n } from '@calendly/i18n'
import { TextInput } from '@calendly/ui/components/text-input'

import { isEnterKey, isEscapeKey } from 'services/keycodes'

export const SearchInput = ({ value, onChange, onSubmit, onClose }) => {
  const handleKeyDown = (e) => {
    if (isEnterKey(e)) { onSubmit() }
    if (isEscapeKey(e)) { onClose() }
  }

  return (
    <TextInput
      name="double_booking_search"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={handleKeyDown}
      placeholder={I18n.t('publisher.event_type_editor.sections.available_hours.bookable_events.add_meeting_exception.input_label')}
      autoFocus
    />
  )
}
